import { css } from "@emotion/react";
import { ChevronRightIcon } from "lucide-react";
import type { ImmutableObject } from "@/lib/immutable";
import type { Product } from "../../../hooks/useInventoryState";

export type ProductBrowserGridItemDepartmentCategorySubcategoryLinksProps = {
	product: ImmutableObject<Product>;
};

export const ProductBrowserGridItemDepartmentCategorySubcategoryLinks: React.FC<
	ProductBrowserGridItemDepartmentCategorySubcategoryLinksProps
> = (props) => {
	const product = props.product;

	return (
		<div className="field categorylinks flex items-start">
			<div className="flex flex-wrap items-center justify-center">
				<span css={css`flex: 0 0 auto;`}>
					{product.InventoryDepartment ?? ""}
				</span>
				<ChevronRightIcon size={14} />
				<span css={css`flex: 0 0 auto;`}>{product.Category ?? ""}</span>
				{product.SubCategoryId && (
					<>
						<ChevronRightIcon size={14} />
						<span css={css`flex: 0 0 auto;`}>{product.SubCategory ?? ""}</span>
					</>
				)}
			</div>
		</div>
	);
};
